// 👑 Admin master: o único usuário isento das travas de permissão do sistema
// (config global de fluxos, fatiar card, etc.). Administradores comuns da empresa
// seguem as regras normalmente — a isenção é só deste e-mail.
export const ADMIN_MASTER_EMAIL = 'andre.alves@refricril.com.br';

export const ehAdminMaster = (email?: string | null): boolean =>
  String(email || '').trim().toLowerCase() === ADMIN_MASTER_EMAIL;
